export enum FolioType {
    PREVENTIVE = "Preventiva",
    CORRECTIVE = "Correctiva",
}